document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.listing-featured-gallery').forEach(gallery => {

        const carousel = gallery.querySelector('.carousel');
        const thumbs   = gallery.querySelectorAll('.listing-thumb');

        if (!carousel || !thumbs.length) return;

        carousel.addEventListener('slid.bs.carousel', function (e) {

            thumbs.forEach(t => t.classList.remove('active'));

            if (typeof e.to !== 'undefined' && thumbs[e.to]) {
                thumbs[e.to].classList.add('active');
            }

        });

    });

});